import(/* webpackMode: "eager" */ "/var/www/bhq-nextjs/src/app/[locale]/(main)/[hospital]/not-found.js");
